import { Static, Type } from '@sinclair/typebox';
import { SurveyStates } from '../../../enums/SurveyStates';
import { makeNullable } from '../../../utils/typeboxHelpers';
import { SurveyTaskProgressStates } from './SurveyTaskProgressStates';

export const surveyTaskTableSchema = Type.Object({
    id: Type.String({ format: 'uuid' }),
    surveyId: Type.String({ format: 'uuid' }),
    name: Type.String(),
    order: Type.Integer(),
    surveyStatus: Type.Enum(SurveyStates),
    progressStatus: Type.Enum(SurveyTaskProgressStates),
    remark: makeNullable(Type.String()),
    updatedById: makeNullable(Type.String({ format: 'uuid' })),
    updatedOn: makeNullable(Type.String()),
    created_at: Type.String(),
    updated_at: Type.String(),
});

/** Workflow for a survey in a certain status. */
export type SurveyTask = Static<typeof surveyTaskTableSchema>;
